import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Title } from '@angular/platform-browser';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { OnLoadAppConfigSuccess } from '../app-state/app-state.action';
import { IAppConfig } from '../../models/AppState';
import { StorageService } from './../Storage/storage.service';
import { AppStateService } from './../app-state/app-state.service';
import { EntryEnum } from '../../models/flow/entry-enum';
import { resolveEntryFromUrl } from '../../shared/utils/entry-url.util';

@Injectable({
  providedIn: 'root'
})
export class AppConfigService {
  private entry: EntryEnum;
  
  constructor(
    private appStateService: AppStateService,
    private storageService: StorageService,
    private http: HttpClient,
    private title: Title
  ) {
    this.entry = resolveEntryFromUrl(window.location.href);
    this.storageService.saveEntry(this.entry);
  }

  loadAppConfig(): Observable<IAppConfig> {
    if (window.location.pathname.toLowerCase().endsWith('/selleridconfig')) {
      return this.getAppConfigJSON('AppConfigSeller.json');
    } else {

      switch (this.entry) {
        case EntryEnum.NewBan:
          return this.getAppConfigJSON('AppConfig.json');
        case EntryEnum.IspBzkPass:
          return this.getAppConfigJSON('AppConfigIpus.json');
        case EntryEnum.ExistBan:
          return this.getAppConfigJSON('AppConfigUpgrade.json');
        case EntryEnum.ExistPack:
          return this.getAppConfigJSON('AppConfigExistPack.json');
        case EntryEnum.NewPack:
          return this.getAppConfigJSON('AppConfigNewPack.json');
        case EntryEnum.Cpo:
          return this.getAppConfigJSON('AppConfigPCO.json');
        case EntryEnum.Relocation:
          return this.getAppConfigJSON('AppConfigMovingInstallation.json');
        case EntryEnum.Vas:
          return this.getAppConfigJSON('AppConfigVas.json');
        case EntryEnum.WsFilter:
          return this.getAppConfigJSON('AppConfigWsFilter.json');
        case EntryEnum.WifiKids:
          return this.getAppConfigJSON('AppConfigWifiKids.json');
        case EntryEnum.Elct:
          return this.getAppConfigJSON('AppConfigElectricity.json');
        default:
          return this.getAppConfigJSON('AppConfig.json');
      }

    }
  }

  private getAppConfigJSON(fileName: string): Observable<IAppConfig> {
    return this.http.get<IAppConfig>(`assets/AppConfig/${fileName}?${Date.now()}`).pipe(
      tap(res => {
        this.appStateService.updateState(new OnLoadAppConfigSuccess(res));
        const currentTitle = this.title.getTitle();
        const newTitle = res.Header?.title ? `בזק - ${res.Header?.title}` : currentTitle;
        this.title.setTitle(newTitle);
      })
    );
  }
}
